import React from "react";
import styled from "styled-components";
import Footer from "./Footer";
import Header from "./Header";

const MainLayoutSection = styled.section``;

const MainLayout = ({ children }) => {
  return (
    <MainLayoutSection>
      <Header />
      {children}
      <Footer />
    </MainLayoutSection>
  );
};

export default MainLayout;
